/*
 * Copyright 2019 FedEx
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubmitInfoService {
  formData: FormData;
  blob: Blob;

  constructor(private httpObj: HttpClient) { }

  updateAwbInfo(oauthToken: string, uniqueIdForAwb: string, country: string, reasonCodeDetailArrayList: Array<Object>,fileInput:Array<File>) {
    const requestUrl = environment.baseUrl + environment.docUploadContext + environment.SUBMIT_REASON_CODE;
    const bodyData = {
      'unique-id': uniqueIdForAwb,
      'country': country,
      'rc_info': reasonCodeDetailArrayList,
    };
    const formData: FormData = new FormData();
    for(const f of fileInput){
      formData.append('file', f);
    }
    formData.append('document', JSON.stringify(bodyData) );
    return this.httpObj.post(requestUrl,formData,this.setOptions(oauthToken));
  }

  processData(data: any) {
    let resStr = new String();
    resStr = data;
    return resStr;
  }

  setOptions(oauthToken: string) {
    const oauthHeader = new HttpHeaders({
      'apikey': oauthToken
    });
    return { headers: oauthHeader };
  }

  base64ToBlob(base64, mime) {
    mime = mime || '';
    var sliceSize = 1024;
    var byteChars = window.atob(base64);
    var byteArrays = [];
    for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
        var slice = byteChars.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: mime});
  }

}
